import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmAppSidebarEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-csm-app/src/csmAppSidebarEntryPoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getQueuesResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { csmQueuesLandingRoute } from '@jira/router-routes__servicedesk-queues-routes/src/csmQueuesLandingRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { queuesLandingEntryPoint } from '@jira/spa-apps__servicedesk-queues-landing/src/queuesLandingEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const csmQueuesLandingPageEntryPoint = createPageEntryPoint({
	main: queuesLandingEntryPoint,
	leftSidebar: {
		sidebar: csmAppSidebarEntryPoint,
		isProjectsExpanded: true,
	},
});

export const csmQueuesLandingRouteEntry: Route = createEntry(csmQueuesLandingRoute, () => ({
	group: 'customer-service',
	isRedirect: true,
	layout: serviceProjectLayout,

	navigation: {},

	resources: [
		...getCustomerServiceL1NavigationResources(),
		...getQueuesResources(),
		getConsolidationStateResource(),
	],

	entryPoint() {
		return fg('csm_appification_standalone_navigation')
			? csmQueuesLandingPageEntryPoint
			: notFoundPageEntrypoint;
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
